import {
  CONFIGURATION_REQUEST,
  CONFIGURATION_SUCCESS,
  CONFIGURATION_FAILURE,
  GET_CONFIGURATION_REQUEST,
  GET_CONFIGURATION_SUCCESS,
  GET_CONFIGURATION_FAILURE,
} from "../types/configuration.types";

const initialState = {
  storeItemResponse: "",
  configData: null,
  error: "",
  loading: false,
};
export const ConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIGURATION_REQUEST:
      return {
        ...state,

        loading: true,
      };
    case CONFIGURATION_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case CONFIGURATION_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GET_CONFIGURATION_REQUEST:
      return { ...state, loading: true };
    case GET_CONFIGURATION_SUCCESS:
      return { ...state, configData: action.payload, loading: false };
    case GET_CONFIGURATION_FAILURE:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
